import React from 'react';
import _ from 'lodash';


import Api from '../api';
import component, {makePath} from './component';
import {HBox, VBox} from './Box';
import DataEditButton from './DataEditButton';
import Link from './Link';
import Flag from './Flag';
import {CancelBig, PlusBig} from './icons';
import teamRoles from './teamRoles';
import {Warning} from './icons';
import notices from './notices';

import {teamCheckActiveTournament} from './teamCheckActiveTournament';

const TeamFull = component('TeamFull', function({popup}) {

  function showError() {
    popup.set({
      icon: Warning,
      message: notices.teamFullCanNotInvite,
      action: 'Понятно',
      iconWidth: 128,
      iconHeight: 128,
      autoClose: true
    })
  }

  return (
    <div onClick={showError} className='TeamPlayer TeamPlayer--Custom'>
      <CancelBig className='TeamPlayer-Full'/>
      <div className='TeamPlayer-FullText'>
        Пригласить в команду
      </div>
    </div>
  );
});

const TeamPlayerAdd = component('TeamPlayerAdd', function() {
  return (
    <Link name='players' query={{sort: 'has_team'}}
          className='TeamPlayer TeamPlayer--Custom TeamPlayer-Button'>
      <PlusBig className='TeamPlayer-Add'/>
      <div className='TeamPlayer-AddText'>
        Пригласить в команду
      </div>
    </Link>
  );
});

const TeamPlayer = component('TeamPlayer', function({data, params, isOwner, anyFreeMainSpots, currentMember, popup, dataObject}) {
  if (!data) {
    return null;
  }

  const teamRoleChangeAlert = function() {
    popup.set({
      icon: Warning,
      message: notices.teamHasActiveTournamentAndRoleChangeFail,
      action: 'Понятно, попробую позже',
      iconWidth: 128,
      iconHeight: 128,
      autoClose: true
    });
  };

  const setRoleTo = async function(roleId) {
    try {
      await Api.captainSetMemberRole({roleId, userId: data.getIn(['user', 'id'])});
      data.setIn(['role'], roleId);
    } catch (r) {
      teamRoleChangeAlert();
    }
  };

  const transferTeam = async function() {
    popup.set({
      icon: Warning,
      message: notices.approveCaptainRoleChange,
      action: 'Да, уверен',
      iconWidth: 128,
      iconHeight: 128,
      onAction: async () => {
        try {
          await Api.captainTransferTeam({userId: data.getIn(['user', 'id'])});
          currentMember.setIn(['role'], data.get('role'));
          data.setIn(['role'], teamRoles.captain.id);
          popup.cursor(['close']).set(true);
        } catch (r) {
          teamRoleChangeAlert();
        }
      }
    });
  };

  const kickPlayer = async function() {
    if(teamCheckActiveTournament(dataObject.get('team'), dataObject.cursor('popup'))) {
      popup.set({
        icon: Warning,
        message: notices.approvePlayerKick,
        action: 'Да, уверен',
        iconWidth: 128,
        iconHeight: 128,
        onAction: async () => {
          const userId = data.getIn(['user', 'id']);
          // TODO how to remove optimistically and then rollback in case of failure?
          try {
            await Api.captainKickPlayer({userId});
            data.remove();
            popup.cursor(['close']).set(true);
          } catch (r) {
            teamRoleChangeAlert();
          }
        }
      });
    }
  };

  const itemImage = data.getIn(['user', 'image']);
  const bgImage = itemImage
      ? itemImage + '?crop=1&w=288&h=240'
      : require('../img/teamEmptyAvatarSquare.png');

  return (
    <div className='TeamPlayer'>
      <div className='TeamPlayer--Wrap'>
        {
          isOwner ?
            <div className="TeamPlayer-Avatar" style={{backgroundImage: `url(${bgImage})`}}>
              {data.get('role') !== teamRoles.captain.id &&
                <div className='TeamPlayer-Actions'>
                  {data.get('role') !== teamRoles.reserve.id && <DataEditButton text='Перевести в запас'  onClick={setRoleTo.bind(this, teamRoles.reserve.id)} />}
                  {data.get('role') !== teamRoles.main.id    && anyFreeMainSpots && <DataEditButton text='Перевести в основу' onClick={setRoleTo.bind(this, teamRoles.main.id)} />}
                  {<DataEditButton text='Сделать капитаном'  onClick={transferTeam} />}
                  {<DataEditButton text='Удалить из команды' onClick={kickPlayer} />}
                </div>
              }
            </div>
            :
            <Link name="playerDetails" params={{id: data.getIn(['user', 'id'])}} className="TeamPlayer-Avatar" style={{
              backgroundImage: `url(${bgImage})`
            }} />
        }
        <div className='TeamPlayer-Role'>
          {_.find(teamRoles, tr => tr.id === data.get('role')).name}
        </div>
      </div>
      <div className='TeamPlayer-Info'>
        <div className="TeamPlayer-Info--Wrap">
          <Flag country={data.getIn(['user', 'country'])}/>
          <Link name="playerDetails" className="TeamPlayer-InfoNickLink" params={{id: data.getIn(['user', 'id'])}}>
            {data.getIn(['user', 'nickname'])}
          </Link>
        </div>
        <span className='TeamPlayer-InfoName'>{data.get('name')}</span>
      </div>

    </div>
  );

});


export default component('TeamPlayersList', function({data, params, isOwner, currentMember, isNew, popup, dataObject}) {
  if (!data) {
    return null;
  }

  data.set(_.sortBy(data.toJS(), 'role'));

  const mainSpots = data.map(p => p.get('role') === teamRoles.main.id).filter(b => b);
  const anyFreeMainSpots = mainSpots.size < 4;

  const renderPlayer = (player, idx) => {
    return <VBox width={1} key={idx}>
      <TeamPlayer data={player} isOwner={isOwner} currentMember={currentMember}
                  anyFreeMainSpots={anyFreeMainSpots} popup={popup} dataObject={dataObject}/>
    </VBox>
  };

  // XXX .map(p => p) ;(
  const firstFour = data.map(p => p).take(4);
  const lastThree = data.map(p => p).skip(4);

  return (
    <div>
      <HBox width={4} noJustify={true} isContainer={true}>
        {firstFour.map(renderPlayer)}
        {isOwner && !isNew && data._val.size < 4 &&
          <VBox width={1}>
            <TeamPlayerAdd />
          </VBox>
        }
      </HBox>
      {data._val.size >= 4 &&
      <HBox width={4} noJustify={true} isContainer={true}>
        {lastThree.map(renderPlayer)}
        {isOwner && !isNew && data._val.size >= 4 && data._val.size < 7 &&
        <VBox width={1}>
          <TeamPlayerAdd isOwner={isOwner}/>
        </VBox>
        }
        {isOwner && data._val.size === 7 &&
        <VBox width={1}>
          <TeamFull popup={popup} />
        </VBox>
        }
      </HBox>
      }
    </div>
  );
});



// WEBPACK FOOTER //
// ./src/components/TeamPlayersList.js